// extracted by mini-css-extract-plugin
export var wordContainer = "_mc-0";